import { sdkRequest } from '@eb/http';

const GET_PLACE_FROM_IP = '/api/v3/geo/place_from_request/';

export const getPlaceFromRequest = () => {
    return sdkRequest(GET_PLACE_FROM_IP);
};
